module.exports = __webpack_public_path__ + "static/media/Data_insight_en_1-1.ae37b3c0.svg";